import { ReactSDKClient } from '@optimizely/react-sdk';
import isEqual from 'lodash/isEqual';
import {
    createOptimizelyReactSDKClient,
    OptimizelyDataFile
} from './optimizely';

let optimizelyReactSDKClient: ReactSDKClient;
let optimizelyDataFile: OptimizelyDataFile;

export const getOptimizelyReactSDKClient = (
    datafile: OptimizelyDataFile
): ReactSDKClient => {
    /**
     * Reuse the instance and take advantage of Next.js serialization.
     * Because we SSR we *must* use our own datafile. We cannot use the sdkKey
     * method to auto fetch the file for us.
     * https://github.com/optimizely/react-sdk#server-side-rendering
     *
     * An undefined datafile should not trigger a rebuild, occurs during client side routing.
     */
    if (
        datafile !== undefined &&
        (!optimizelyReactSDKClient || !isEqual(optimizelyDataFile, datafile))
    ) {
        optimizelyReactSDKClient = createOptimizelyReactSDKClient(datafile);
        optimizelyDataFile = datafile;
    }

    return optimizelyReactSDKClient;
};
